import React, { useState, useEffect } from 'react'
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import SideBar from '../sidebar/sidebar'
import { Link } from 'react-router-dom'
import Axios from 'axios'
import ReactHtmlParser from 'react-html-parser'
import { BASE } from '../api/api';
import { render } from 'react-dom';


class Covenants extends React.Component {

    constructor(){
        super()
        this.state={
            conv: []
        }
    }
    componentDidMount() {
        Axios.get(BASE + 'jsonapi/node/page?filter[title]=Covenants of the Prophet Muhammed')
            .then((res) => {
                this.setState({
                    conv:res.data.data
                })
            })
    }
    render() {

        return (
            <div>
                <Header />
                <div className='container side-arrange' style={{ minHeight: '71.6vh' }}>
                    <SideBar data={'data2'} />
                    <div className='columns'>
                        <div className="crumbs"><Link to='/'>Home</Link> / <Link to='/convenants'>Covenants of the Prophet Muhammed</Link></div>
                        <div className="page-title">
                            <div className="title-wrapper">
                                <div className="">
                                    <h1 className="heading">{this.state.conv.length ? this.state.conv[0].attributes ? this.state.conv[0].attributes.title : '' : ""}</h1>
                                </div>
                            </div>
                        </div>
                        <div className="main-content listing">
                            <div className="content-p">
                                <div className="row">
                                    <div className="region region-content">
                                        <div className="">
                                            {this.state.conv.length ? this.state.conv[0].attributes ? this.state.conv[0].attributes.body ? ReactHtmlParser(this.state.conv[0].attributes.body.value) : '' : "" : ''}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='construct-footer'>
                    <Footer />
                </div>

            </div>
        )
    }
}
export default Covenants;